import React, { useEffect, useState, useContext } from 'react';
import { useSelector } from "react-redux";
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from "react-router-dom";
import { LanguageContext } from './languageContext';
import { dispatchT_Language } from '../../Redux/ActionCreator';
import { useDispatch } from 'react-redux';
import SideBar from './Side-Bar';
import logo from "./logo.png";
import TranslateIcon from '@mui/icons-material/Translate';

const TopBar = (props) => {

	const { language, handleLanguageChange } = useContext(LanguageContext);
	const t_lang = useSelector(lg => lg.t_lang)
	const profile_stat = useSelector(prev => prev.login)
	const trans = useSelector(e => e.t_lang);
  const dispatch = useDispatch();
	const [ anchorEL, setAnchorEL ] = useState(null);
	const [showMenu, setShowMenu] = useState(false);
	const open = Boolean(anchorEL);
	
	const handleClick = (event) => {
		setAnchorEL(event.currentTarget)
	}

	const handleShowMenu = () => {
		setShowMenu(!showMenu);
	}

	const handleClose = (lg) => {
		handleLanguageChange(lg);
		dispatch(dispatchT_Language(lg));

		console.log("language selected", lg)
		setTimeout(() => {
      console.log(language['Submit'])
    }, 3000);
		
		setAnchorEL(null);
	}

  const userPics = useSelector(prev => prev.userInfo)
  const [ picLink, setPicsLink ] = useState('');

	useEffect(() => {
    if (userPics.user !== null) {
      setPicsLink(userPics.user.profile_pics);
    }
		
		if (t_lang.selected === 'sp') {
			handleLanguageChange("sp");
		} else if (t_lang.selected === 'en') {
			handleLanguageChange("en");
		}
  }, [userPics, t_lang.selected]);

	return (
		<header className="flex justify-between items-center px-8 py-3 border-b-[1.5px] border-sec-300 col-start-1 col-end-3 row-start-1 row-end-2 max-w-[100vw]">
			{
				profile_stat.profile_status.AcctType === "Client" ? 
				<Link to={profile_stat.profile_status.profile_status === true && profile_stat.profile_status.AcctType === "Client" ? "/user/dashboard" : "/user/dashboard1"}>
				<figure>
					<img
						src={logo}
						alt="Moil Logo"
						className="w-[50px] cont:w-[100px]"
					/>
					<figcaption className="sr-only">Moil Logo</figcaption>
				</figure>
			</Link> : 
			<Link to={profile_stat.profile_status.profile_status === true && profile_stat.profile_status.AcctType === "Official" ? "/user/employer/profile" : "/user/employer/form"}>
				<figure>
					<img
						src={logo}
						alt="Moil Logo"
						className="w-[50px] cont:w-[100px]"
					/>
					<figcaption className="sr-only">Moil Logo</figcaption>
				</figure>
			</Link>
			}
			<div className="flex justify-between items-center gap-5">
				<figure>
				<Avatar alt="Remy Sharp" src={picLink} />
				</figure>
				<div>
				<button type="button"
					id="basic-button"
					aria-controls={open ? 'basic-menu' : undefined}
					aria-haspopup="true"
					aria-expanded={open ? 'true' : undefined}
					onClick={handleClick}
					className={`${props.topBarShowMenu === true ? 'hidden' : ''} md:block`}
				>
					<figure className="flex gap-2">
						<figcaption className="text-sm text-pry-800 font-normal">
							{trans.selected === "en" ? <>{language["spanish_T"]}</> : <>{language["english_T"]}</>}
						</figcaption>
					</figure>
				</button>
				<div className='flex items-center'>
					<div className={`${props.topBarShowMenu === true ? 'visible' : 'hidden'} md:hidden  mr-3`}>
						<TranslateIcon 
						
						id="basic-button"
						aria-controls={open ? 'basic-menu' : undefined}
						aria-haspopup="true"
						aria-expanded={open ? 'true' : undefined}
						onClick={handleClick} />
					</div>
					
					{
						props.topBarShowMenu && <button className='md:hidden relative' onClick={handleShowMenu}>
						<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0 0.75C0 0.551088 0.0790175 0.360322 0.21967 0.21967C0.360322 0.0790175 0.551088 0 0.75 0H11.25C11.4489 0 11.6397 0.0790175 11.7803 0.21967C11.921 0.360322 12 0.551088 12 0.75C12 0.948912 11.921 1.13968 11.7803 1.28033C11.6397 1.42098 11.4489 1.5 11.25 1.5H0.75C0.551088 1.5 0.360322 1.42098 0.21967 1.28033C0.0790175 1.13968 0 0.948912 0 0.75ZM0 4.75C0 4.55109 0.0790175 4.36032 0.21967 4.21967C0.360322 4.07902 0.551088 4 0.75 4H11.25C11.4489 4 11.6397 4.07902 11.7803 4.21967C11.921 4.36032 12 4.55109 12 4.75C12 4.94891 11.921 5.13968 11.7803 5.28033C11.6397 5.42098 11.4489 5.5 11.25 5.5H0.75C0.551088 5.5 0.360322 5.42098 0.21967 5.28033C0.0790175 5.13968 0 4.94891 0 4.75ZM0 8.75C0 8.55109 0.0790175 8.36032 0.21967 8.21967C0.360322 8.07902 0.551088 8 0.75 8H11.25C11.4489 8 11.6397 8.07902 11.7803 8.21967C11.921 8.36032 12 8.55109 12 8.75C12 8.94891 11.921 9.13968 11.7803 9.28033C11.6397 9.42098 11.4489 9.5 11.25 9.5H0.75C0.551088 9.5 0.360322 9.42098 0.21967 9.28033C0.0790175 9.13968 0 8.94891 0 8.75Z" fill="#AAAAAA"/>
						</svg>
						<div className='absolute max-w-[280px] bg-white rounded-xl right-0 top-[10px]'>
							{
								showMenu && <SideBar isForMenu={true} />
							}
						</div>
						</button>
					}
					</div>
				</div>

				<Menu
					id="basic-menu"
					anchorEl={anchorEL}
					open={open}
					onClose={handleClose}
					MenuListProps={{
						'aria-labelledby': 'basic-button',
					}}
				>
					<MenuItem onClick={() => handleClose("en")}>English</MenuItem>
					<MenuItem onClick={() => handleClose("sp")}>Español</MenuItem>
				</Menu>
			</div>
		</header>
	);
};

export default TopBar;
